import { Card, FormField, Heading, InputWidth, ReadOnlyField } from '@msaf/core-react'
import { WellGeothermalPressureFields } from '../../../../types/form-types'

interface WellGeothermalPressureInterface {
  fields: Partial<WellGeothermalPressureFields>
  index: number
  isLoading: boolean
}

export default function WellGeothermalPressureView({ fields, index, isLoading }: WellGeothermalPressureInterface) {
  return (
    <Card>
      <Heading isSkeleton={isLoading} level={4}>
        Reading {index + 1}
      </Heading>

      <FormField isSkeleton={isLoading} label='Date' labelId='date'>
        <ReadOnlyField
          fieldSize={InputWidth.large}
          isSkeleton={isLoading}
          labelledBy='date'
          value={`${fields['date'] ?? ''}`}
        />
      </FormField>

      <FormField isSkeleton={isLoading} label='Depth (m)' labelId='depth'>
        <ReadOnlyField
          fieldSize={InputWidth.large}
          isSkeleton={isLoading}
          labelledBy='depth'
          value={`${fields['depth'] ?? ''}`}
        />
      </FormField>

      <FormField isSkeleton={isLoading} label='Pressure (kPa)' labelId='pressure'>
        <ReadOnlyField
          fieldSize={InputWidth.large}
          isSkeleton={isLoading}
          labelledBy='pressure'
          value={`${fields['pressure'] ?? ''}`}
        />
      </FormField>
    </Card>
  )
}
